import drawer from "./drawer";
const sampleCart = {

    ui: {
        originPopin: null
    },

    init: function() {
        this.bindUI();
        this.bindEvents();
    },

    bindUI: function() {
        this.ui.$body = $('body');
        this.ui.$formAddSample = $('.js-form-add-sample');
        this.ui.$btnCart = $('.js-button-cart');
    },

    bindEvents: function() {
        this.ui.$body.on('click', '.js-button-remove-sample', this.removeSample.bind(this));
        this.ui.$formAddSample.on('submit', this.submitFormAddSample.bind(this));
        this.ui.$btnCart.on('click', this.refreshDrawerCart.bind(this));
    },
    refreshDrawerCart: function() {
        let $btn = $('.js-button-cart');
        $.ajax({
            url: $btn.data('url'),
            type: 'GET',
            success: (data) => {
                // console.log("success");
                // console.log(data);
                let $drawerCart = $("#drawer_cart");
                $drawerCart.find('.js-drawer-cart-content').replaceWith(data.render);
                drawer.openDrawer($drawerCart);
                $drawerCart.find('.js-drawer-cart-content').find(".js-addScrolledBottomClassOnBottomScroll").on("scroll", window.checkScrolledBottom);
            },
            error: (data) => {
                // console.log("error");
            }
        })
    },
    removeSample: function(e) {
        let $btn = $(e.currentTarget);
        let refreshPage = $btn.data('refresh')
        let targetPage = $btn.data('targetPage')
        $.ajax({
            url: $btn.data('url'),
            type: 'DELETE',
            success: (data) => {
                if(refreshPage){
                    if (targetPage){
                        window.location.replace(targetPage);
                    } else {
                        let $shippingAddressDrawerCart = $("#shippingAddress_drawer_cart");
                        let $validateAddressDrawerCart = $("#validateAddress_drawer_cart");
                        $.ajax({
                            url: '/ajax/cart/refresh?hide_btnGroup=true&refresh=true',
                            type: 'GET',
                            success: (data) => {
                                if($shippingAddressDrawerCart.length > 0){
                                    $shippingAddressDrawerCart.find('.js-drawer-cart-content').replaceWith(data.render);
                                }
                                if($validateAddressDrawerCart.length > 0){
                                    let $sampleNumbers = this.ui.$body.find('#sampleNumbers')
                                    console.log($sampleNumbers)
                                    if($sampleNumbers.length > 0){
                                        $sampleNumbers.html(data.quantity)
                                    }
                                    $validateAddressDrawerCart.find('.js-drawer-cart-content').replaceWith(data.render);
                                }

                            },
                            error: (data) => {
                                // console.log("error");
                            }
                        })
                    }
                } else {
                    sampleCart.refreshDrawerCart();
                    let $shippingAddressDrawerCart = $("#shippingAddress_drawer_cart");
                    let $validateAddressDrawerCart = $("#validateAddress_drawer_cart");

                    if($shippingAddressDrawerCart.length > 0){
                        $.ajax({
                            url: '/ajax/cart/refresh?hide_btnGroup=true&refresh=true',
                            type: 'GET',
                            success: (data) => {
                                $shippingAddressDrawerCart.find('.js-drawer-cart-content').replaceWith(data.render);
                            },
                            error: (data) => {
                                // console.log("error");
                            }
                        })
                    }
                    if($validateAddressDrawerCart.length > 0){
                        let $sampleNumbers = this.ui.$body.find('#sampleNumbers')
                        $.ajax({
                            url: '/ajax/cart/refresh?hide_btnGroup=true&refresh=true',
                            type: 'GET',
                            success: (data) => {
                                if($sampleNumbers.length > 0){
                                    $sampleNumbers.html(data.quantity)
                                }
                                $validateAddressDrawerCart.find('.js-drawer-cart-content').replaceWith(data.render);
                            },
                            error: (data) => {
                                // console.log("error");
                            }
                        })
                    }
                }
            },
            error: (data) => {
                // console.log("error");
            }
        })
    },
    submitFormAddSample: function(e) {
        e.preventDefault();
        let $form = $(e.currentTarget);
        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serializeArray(),
            success: (data) => {
                // console.log("success");
                // console.log(data);
                drawer.closeDrawer($("#drawer_sample"));
                sampleCart.refreshDrawerCart();
            },
            error: (data) => {
                // console.log("error");
            }
        })
    },
};

module.exports = sampleCart;